"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledBadge = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _utils = require("../lib/utils");

var _templateObject;

var StyledBadge = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: inline-flex;\n  border-radius: ", ";\n  justify-content: center;\n  height: 20px;\n  min-width: 20px;\n  align-items: center;\n  padding: 0px 6px;\n  ", "\n  box-sizing: border-box;\n  background-color: ", ";\n  color: ", ";\n  ", "\n"])), (0, _utils.getBorderRadius)('primary'), (0, _utils.getTypography)('bodyLight'), function (props) {
  return (0, _utils.getPalette)(props.bg, 'c03')(props);
}, function (props) {
  return props.color;
}, _styledSystem.space);

exports.StyledBadge = StyledBadge;